<template>
    <div class="animated fadeIn vld-parent custom-100">
        <b-row>
            <b-col sm="12">
                <searchBar ref="searchBar" :user-groups="userGroups" :is-bauhof-user="hasBauhofPosteingang"
                           :user-group-select="userGroupSelect"
                            :on-search="queryData"></searchBar>
            </b-col>
        </b-row>
        <b-row class="custom-flex-1">
            <b-col sm="12">
                <auftraegeTable ref="auftraegeTable" :table-data="data" :all-groups="allGroups" :show-freigabe="settings.fg_stufe1"></auftraegeTable>
            </b-col>
        </b-row>
    </div>
</template>

<script>
    import searchBar from './search_bar'
    import auftraegeTable from './aufgaben_table'
    import {Redirect_500, Redirect_Login, Server_URL} from "../../shared/utils";
    import {decryptAES} from "../../shared/crypto";

    export default {
        name: "Auftraege_Offen",
        components: {'searchBar':searchBar, 'auftraegeTable': auftraegeTable},
        data() {
            return {
                loader: undefined,
                // SearchbarProps
                userGroups: [],
                userGroupSelect: undefined,
                data: [],
                currentPage: 1,
                settings: {fg_stufe1: false},
                allGroups: [],
              hasBauhofPosteingang: false,

            }
        },
        created() {
            this.showLoader();
            this.$http.get(
                Server_URL+'/auftragsbuch/data/fetch'
            ).then(this.responseOkGet, this.responseError)
        },
        methods: {

            showLoader() {
                this.loader = this.$loading.show();
            },
            hideLoader() {
                if (this.loader !== undefined) {
                    this.loader.hide();
                    this.loader = undefined;
                }
            },
            responseOkGet(response) {
                this.hideLoader();
                if (response.status === 200 && response.body.status === "ok") {
                    let groups = response.body.data.groups;
                    let module_groups = response.body.data.module_groups;
                    let augr = response.body.data.augrs;
                    this.userGroups.push({text: "Alle", value: {id: "all", module: "all"}});
                    this.userGroupSelect = {id: "all", module: "all"};
                  this.hasBauhofPosteingang = response.body.data.has_bauhof_posteingang;
                  if (!this.hasBauhofPosteingang) {
                    for (let i = 0; i < module_groups.length; i++) {
                      let res = JSON.parse(sessionStorage.getItem(module_groups[i].name));
                      if (res !== null) {
                        this.userGroups.push({text: res.username, value: module_groups[i]});
                      } else {
                        switch (module_groups[i].module) {
                          case "ab":
                            module_groups[i].name += " (Auftragsbuch)";
                            break;
                          case "mm":
                            module_groups[i].name += " (Mängelmelder)";
                            break;
                        }
                        this.userGroups.push({text: module_groups[i].name, value: module_groups[i]});
                      }
                    }
                  } else {
                    this.userGroups.push({text: "Bauhof", value: {id: "Bauhof", module: "ab"}});
                    for (let i = 0; i < module_groups.length; i++) {
                      if (module_groups[i].module === "mm") {
                        module_groups[i].name += " (Mängelmelder)";
                        this.userGroups.push({text: module_groups[i].name, value: module_groups[i]});
                      }
                    }
                  }
                  this.allGroups = response.body.data.all_groups;

                    this.settings = response.body.data.global_settings;
                    this.queryData("M", {id: "all", module: "all"}, -1, "");
                } else {
                    window.location = Redirect_500;
                }
            },
            responseOkFetch(response) {
                this.hideLoader();
                this.$refs.auftraegeTable.currentPage = 1;
                this.$refs.searchBar.onFirstSearch();

                if (response.status === 200 && response.body.status === "ok") {
                    this.data = response.body.data;
                        this.decryptData();
                } else {
                    window.location = Redirect_500;
                }
            },
            responseError(response) {
                this.hideLoader();
                if (response.status === 401) {
                    window.location = Redirect_Login;
                } else {
                    window.location = Redirect_500;
                }
            },
            queryData(typ, group, year, searchText, count, augr) {
                let module = "";
                module = group.module;
                group = group.id;
                this.showLoader();
                this.$http.get(
                    Server_URL+'/auftragsbuch/data/fetch_aufgaben/'+group+
                    "?search_typ="+typ+
                    "&search_text="+searchText+
                    "&year="+year+
                    "&count="+count+
                    "&offen=0"+ "&module=" + module
                ).then(this.responseOkFetch, this.responseError)
            },
            async decryptData() {
                for (let i = 0; i < this.data.length; i++) {
                    try {
                        if (this.data[i].gi_memo !== null && this.data[i].gi_memo !== "") {
                            this.data[i].gi_memo = await decryptAES(sessionStorage.getItem("aes"), this.data[i].gi_memo);
                        }
                    } catch (e) {
                        //console.log(e)
                    }
                }
            },
        },
    }
</script>

<style scoped>

</style>
